import { buildMobileAppHref } from '@/config/tenant-route';
import { Button, Result } from 'antd-mobile';
import { t } from 'i18next';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import s from './style.module.less';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // 可在此处上报错误到监控平台
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = buildMobileAppHref('/');
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={s.root}>
          <Result
            description={
              this.state.error?.message ||
              t('component:error_boundary_subtitle')
            }
            status="error"
            title={t('component:error_boundary_title')}
          />
          <div className={s.action}>
            <Button color="primary" onClick={this.handleReset}>
              {t('component:back_home')}
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
